import { initializeApp } from 'firebase/app'
import envConfig from "../../src/envConfig.js";

export default initializeApp(envConfig.firebaseConfig);
